'use strict';
var parent = require('../../actual/symbol/to-string-tag');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/symbol/to-string-tag.js
// module id = 643
// module chunks = 13